module.exports = __webpack_public_path__ + "assets/img/mimi.47e01fdc.png";